import React from 'react';
import { i18n_begin_your_journey_to_well_being } from '@yi/i18n/phrases/i18n_begin_your_journey_to_well_being';
import { i18n_play_series_now_for_free } from '@yi/i18n/phrases/i18n_play_series_now_for_free';
import { i18n_start_your_free_trial } from '@yi/i18n/phrases/i18n_start_your_free_trial';

import {
  getSeriesDescription,
  getSeriesHeroImgSrc,
  getSeriesTitle,
  getSeriesTotalEpisodes,
  getSeriesTotalSeasons,
  getSeriesTrailerMediaId,
  rememberHasPromoSeen,
  Series,
} from '~/src/common/lean-back';
import { useCurrentUser } from '~/src/common/user';
import {
  Description,
  DetailsBody,
  PageHeader,
  PageHeadingsGroup,
  Title,
  WatchTrailerButton,
} from '~/src/components/LeanBack/common-components';
import { MembershipCTA } from '~/src/components/MembershipCTA';

import { ContinueWatching } from './ContinueWatching';
import { Container } from './elements';
import { Hero } from './Hero';
import { PlayResumeButton } from './PlayResumeButton';
import { Seasons } from './Seasons';
import { SuggestedEpisode } from './SuggestedEpisode';
import { TotalSeasonsEpisodesTitle } from './TotalSeasonsEpisodesTitle';

type Props = { series: Series };

export const SeriesItemPage: React.FC<Props> = ({ series }) => {
  rememberHasPromoSeen();
  const { isLoggedIn } = useCurrentUser();
  return (
    <>
      <Hero imgSrc={getSeriesHeroImgSrc(series)} />
      <Container>
        <DetailsBody>
          <PageHeader>
            <PageHeadingsGroup>
              <Title>{getSeriesTitle(series)}</Title>
              <TotalSeasonsEpisodesTitle
                seasons={getSeriesTotalSeasons(series)}
                episodes={getSeriesTotalEpisodes(series)}
              />
            </PageHeadingsGroup>
            <WatchTrailerButton mediaId={getSeriesTrailerMediaId(series)} />
          </PageHeader>
          <MembershipCTA headingText={i18n_play_series_now_for_free} />
          <PlayResumeButton series={series} />
          <div>
            {isLoggedIn && <ContinueWatching series={series} />}
            <Description>{getSeriesDescription(series)}</Description>
          </div>
          <MembershipCTA
            centeredDesktop
            headingText={i18n_begin_your_journey_to_well_being}
            headingStyle={{ textTransform: 'uppercase' }}
            buttonText={i18n_start_your_free_trial}
          />
          <Seasons series={series} />
          <SuggestedEpisode />
        </DetailsBody>
      </Container>
    </>
  );
};
